import { FlowContentType } from '@enums';

import { Content } from '../types';

export const getContentTypeAndSlug = (
    content?: Content
): {
    content_type: FlowContentType;
    content_slug: string;
} => {
    switch (content?.__typename) {
        case 'ComponentPagesFlowPage':
            return {
                content_type: FlowContentType.FlowPage,
                content_slug: content.FlowPage?.Slug || '',
            };

        case 'ComponentContentStory':
            return {
                content_type: FlowContentType.Story,
                content_slug: content.Story?.Slug || '',
            };

        case 'ComponentFormsForm':
            return {
                content_type: FlowContentType.Survey,
                content_slug: content.Form?.Slug || '',
            };

        default:
            return {
                content_type: '' as FlowContentType,
                content_slug: '',
            };
    }
};
